import { ModelModel } from './../../models/model.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ProductModel} from '../../models/product.model';
import { ProductCategoryService } from '../../services/product-category.service';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-accessory-details',
  templateUrl: './accessory-details.component.html',
  styleUrls: ['./accessory-details.component.css']
})
export class AccessoryDetailsComponent implements OnInit  {
  model: ModelModel = new ModelModel();
  accessory: ProductModel = new ProductModel();
  fullImagePath: string;
  iscommercial = 'false';
  constructor(private service: ProductCategoryService, private hostElement: ElementRef) {}

  async ngOnInit() {
    // const modelAtt = this.hostElement.nativeElement.getAttributeNode('model');
    // const modelId: string = modelAtt && modelAtt.value ? modelAtt.value : '';
    const accessoryAtt = this.hostElement.nativeElement.getAttributeNode('accessory');
    const accessoryId: string = accessoryAtt && accessoryAtt.value ? accessoryAtt.value : '';

    const lineAtt = this.hostElement.nativeElement.getAttributeNode('iscommercial');
    this.iscommercial = lineAtt && lineAtt.value ? lineAtt.value : 'false';
    // const prodTypeAtt = this.hostElement.nativeElement.getAttributeNode('product-type');
    // const prodTypeId: string = prodTypeAtt && prodTypeAtt.value ? prodTypeAtt.value : '';
    // this.product = await this.getproductbyId(prodTypeId);
    // this.model = this.product.models.find(x => x.id == modelId);
    // this.accessory = this.model.relatedAccessories.find(x => x.id == accessoryId);
    this.accessory = await this.getproductbyId(accessoryId);
    this.fullImagePath = '/angular/dist/assets/Locater.svg';
  }


  async getproductbyId(Id?: string): Promise<ProductModel> {
    let result: ProductModel = new ProductModel();
    await this.service.getProductById(Id)
    .then(
      res => {
      if (res) {
        let retproduct: any;
        retproduct = res as any;
        result =  retproduct ? new ProductModel(retproduct) : new ProductModel();
        return result;
      }
    }
  ).catch(err => console.log(err));
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/containers/accessory-details/accessory-details.component.ts